import httpClient from "./httpClient";

const getCommonLinks = () => httpClient.get("/common_links");

const getCurrentYear = () => httpClient.get("/current_year");

export { getCommonLinks, getCurrentYear };
